import { SchedulerSettingsTabs } from '@lp/features/Scheduler/components';
import { OMSSchedulerSettingsInputsTab, OMSSchedulerSettingsRulesTab } from './components';

export const SchedulerOMSSettings = () => {
  return (
    <SchedulerSettingsTabs inputsTab={<OMSSchedulerSettingsInputsTab />} rulesTab={<OMSSchedulerSettingsRulesTab />} />
  );
};
